import React, {Component} from "react";

class InputUploadLogoOptions extends Component {
    constructor(props) {
        super(props);

        const name = "BLOCK_ITEM_" + this.props.blockItem.id + (this.props.blockItem.isArray ? "[]" : "");
        this.state = {
            [name]: this.props.blockItem.values[0]
        };

        const e = {target: {name: name, value: this.props.blockItem.values[0]}};
        this.props.onChange(e);

        this.change = this.change.bind(this);
    }

    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
        this.props.onChange(e);
    }

    getBase64 = file => {
        return new Promise(resolve => {
            let baseURL = "";
            // Make new FileReader
            let reader = new FileReader();

            // Convert the file to base64 text
            reader.readAsDataURL(file);

            // on reader load somthing...
            reader.onload = () => {
                // Make a fileInfo Object
                baseURL = reader.result;
                resolve(baseURL);
            };
        });
    };

    handleFileInputChange = e => {
        let { file } = this.state;
        file = e.target.files[0];

        this.getBase64(file)
            .then(result => {
                console.log("Base64 - File Is", result);
                let image = result!= null && result.split(",").length > 2 ? "" : result.split(",")[1];
                let inputClassName = 'BLOCK_ITEM_9010110';
                let element = document.querySelector('.' + inputClassName + ' input');
                let nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
                nativeInputValueSetter.call(element, image);
                let ev2 = new Event('input', {bubbles: true});
                element.dispatchEvent(ev2);

                let img = document.querySelector('[name=IMG_BLOCK_ITEM_9010110]');
                img.src = result;
            })
            .catch(err => {
                console.log(err);
            });
    };

    render() {
        const name = "base64File";
        return (
            <div className="coreBlockItem-value">
                <input type="file" className="coreBlockItem-input coreBlockItem-typeFile" onChange={this.handleFileInputChange} />
            </div>
        );
    }
}

export default InputUploadLogoOptions;
